import gql from "graphql-tag";

export default gql`
  mutation deleteDeployment($deploymentId: ID, $customerId: ID) {
    deleteDeployment(deploymentId: $deploymentId, customerId: $customerId) {
      id
      codename
    }
  }
`;
